<template>
  <span class="nova-modal-close" @click="$emit('click')">
    <div class="__btn"></div><div class="__circle"></div>
    <i class="ti-close"></i>
    <svg class="svg-angle svg-angle-left" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
    <svg class="svg-angle svg-angle-right" width="29" height="29" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
  </span>
</template>
<script>
export default {
  inheritAttrs: true,
  name: "nova-close",
}
</script>